
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Mail, X, ArrowLeft } from 'lucide-react';

const NoSignupPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-background to-secondary/20 p-4">
      <Card className="w-full max-w-md shadow-lg border-primary/20">
        <div className="flex items-center justify-center p-6 bg-primary/5 rounded-t-lg border-b">
          <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
            <X className="h-6 w-6 text-primary" />
          </div>
        </div>
        
        <CardContent className="p-6 text-center space-y-4">
          <h1 className="text-2xl font-bold">No Public Registration</h1>
          
          <p className="text-muted-foreground">
            We're sorry, but public signup is not available at this time. Trotting the Word is an invite-only platform for travel writers and content creators.
          </p>
          
          <div className="bg-muted p-4 rounded-lg mt-4">
            <h2 className="font-medium mb-2">Interested in joining?</h2>
            <p className="text-sm text-muted-foreground">
              If you're a travel writer, photographer, or content creator interested in contributing to Trotting the Word, please contact us directly.
            </p>
          </div>
        </CardContent>
        
        <CardFooter className="p-6 pt-0 flex flex-col space-y-3">
          <Link to="/contact-us" className="w-full">
            <Button className="w-full" variant="default">
              <Mail className="mr-2 h-4 w-4" />
              Contact Us
            </Button>
          </Link>
          
          <Link to="/" className="w-full">
            <Button className="w-full" variant="outline">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
};

export default NoSignupPage;
